import React, { Component } from 'react';
import profile from './../../assets/images/background.jpg'
import { Link } from 'react-router-dom'
class Sidebar extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    logOut = () => {
        localStorage.removeItem('token');
    }
    handleToggle=() =>{
        this.props.toggleMenu()
    }
    render() {
        return (
            <aside className="sidebar">
                <figure>
                    <img src={profile} alt="#" />
                    <figcaption>
                        خوش آمدید
                    </figcaption>
                </figure>
                <ul className="menu-links">
                    <li onClick={this.handleToggle}>
                        <Link to="/">
                            <i className="fa fa-tasks"></i>
                            مدیریت آیتم ها
                            </Link>
                    </li>
                    <li onClick={this.handleToggle}>
                        <Link to="/about"><i className="fa fa-info-circle"></i>
                            درباره ما</Link>
                    </li>
                    <li onClick={this.handleToggle}>
                        <Link to="/setting"><i className="fa fa-info-circle"></i>
                            تنظیمات</Link>
                    </li>
                    <li onClick={this.logOut} >
                        <Link to="/login"><i className="fa fa-sign-out"></i>
                            خروج</Link>
                    </li>
                </ul>
            </aside>
        );
    }
}

export default Sidebar;